import styled, { keyframes } from '@eduzz/houston-styles';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 2;
  background-color: #fff;
`;

const LoaderIndeterminateAnimation = keyframes`
  0% {
    transform: translateX(-100%);
    background-color: #0d2772;
  }
  100% {
    transform: translateX(100%);
    background-color: #0d2772;
  }
`;

export const Box = styled.div`
  width: 300px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const LoaderLine = styled.div`
  position: relative;
  display: block;
  width: 100%;
  overflow: hidden;
  height: 4px;
  background-color: rgba(13, 39, 113, 0.25);

  > div {
    background-color: inherit;
    position: relative;
    height: 100%;

    &:before {
      content: '';
      position: absolute;
      background-color: inherit;
      top: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      animation: ${LoaderIndeterminateAnimation} 1.5s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    }
  }
`;
